import clsx from "clsx";
import { type ReactNode } from "react";
import styles from "./Overlay.module.scss";

export interface OverlayProps {
    className?: string;
    children?: ReactNode;
}

const Overlay = (props: OverlayProps) => {
    const { className, children } = props;

    return (
        <div className={clsx(styles.overlay, className)} data-deci-overlay="true">
            {children}
        </div>
    );
};

export default Overlay;

